import { FormControl, FormLabel, HStack, Input } from "@chakra-ui/react";

const CurrencyAmountInput = ({
  label,
  value,
  onChange,
  size = "md",
  height = "auto", // Chakra Input height is normally based on size, but this gives override
}) => {
  const handleCcyChange = (e) => {
    onChange({
      ...value,
      ccy: e.target.value.toUpperCase().slice(0, 3),
    });
  };

  const handleValueChange = (e) => {
    onChange({
      ...value,
      value: e.target.value,
    });
  };

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <HStack spacing={2}>
        <Input
          placeholder="CCY"
          maxLength={3}
          width="120px"
          size={size}
          height={height}
          value={value?.ccy || ""}
          onChange={handleCcyChange}
        />
        <Input
          placeholder="Amount"
          type="number"
          width="300px"
          // right justify the input
          textAlign="right"
          pattern="[0-9]*"
          inputMode="numeric"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          autoCapitalize="off"
          size={size}
          height={height}
          value={value?.value || ""}
          onChange={handleValueChange}
        />
      </HStack>
    </FormControl>
  );
};

export default CurrencyAmountInput;
